<template>
  <svg
    viewBox="0 0 365.5 413.26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="A"
        gradientUnits="userSpaceOnUse"
        x1="15.4"
        x2="352.22"
        y1="206.43"
        y2="206.43"
      >
        <stop
          offset="0"
          stop-color="#232c54"
        />
        <stop
          offset=".14"
          stop-color="#212f58"
        />
        <stop
          offset=".65"
          stop-color="#183966"
        />
        <stop
          offset=".99"
          stop-color="#153e6b"
        />
      </linearGradient>
    </defs>
    <path
      d="M310.93 3.2H182.75l-128.3.12-51.6 78.5.17 1.72c.06.5 1.73 21.67 9.94 63.7 5.18 26.6 15.4 67.2 25 98.23 14.6 47.27 35.12 85 54.7 112.2 25 34.7 58.2 52.35 90.14 52.46h.24c31.95-.13 65.12-17.8 90.1-52.54 19.56-27.15 40-65 54.6-112.24 9.6-31 19.8-71.65 25-98.25 8.1-42 9.82-63.22 9.88-63.7l.18-1.72z"
      fill="#18223d"
    />
    <path
      d="M305.4 13.67l45.7 69.4c-.8 7.57-3.2 27.64-9.5 60.26-5.3 27.4-15.55 67.78-24.95 98.2-15.86 51.47-37.82 88.16-53.38 109.84-21.65 30.1-51 47.48-80.5 47.6-29.42-.1-58.73-17.45-80.4-47.54-15.64-21.66-37.57-58.34-53.48-109.8-9.43-30.46-19.73-70.84-25-98.17-6.36-32.62-8.76-52.68-9.57-60.25l45.6-69.45 245.48-.1"
      fill="url(#A)"
    />
    <path
      d="M13.23 69.13L9.6 74.86l-3.63 6.46 9.05 2.1 1.9-3.32-.01-16.74-3.7 5.78z"
      fill="#2c4988"
    />
    <g fill="#2d4a89">
      <path d="M16.92 63.35l.01 16.74 3.63-5.6-.01-16.86-3.63 5.73z" />
      <path d="M20.55 57.62l.01 16.86 3.62-5.54V51.9l-3.63 5.73z" />
    </g>
    <path
      d="M24.18 51.9v17.05l3.7-5.54-.01-17.3-3.7 5.78z"
      fill="#2d4b8a"
    />
    <path
      d="M27.88 63.4l3.62-5.54V40.38l-3.63 5.73.01 17.3z"
      fill="#2f4d8a"
    />
    <path
      d="M35.13 34.65l-3.63 5.73v17.48l3.63-5.54V34.65z"
      fill="#2f4e8c"
    />
    <path
      d="M38.83 46.72l-.01-17.85-3.7 5.78v17.67l3.7-5.6z"
      fill="#304e8c"
    />
    <path
      d="M42.45 41.18V23.14l-3.63 5.73.01 17.85 3.62-5.54z"
      fill="#324f8c"
    />
    <path
      d="M46.08 35.63V17.4l-3.63 5.73v18.04l3.63-5.55z"
      fill="#33508d"
    />
    <path
      d="M49.77 30.1V11.63l-3.7 5.78v18.22l3.7-5.54z"
      fill="#34518e"
    />
    <path
      d="M53.4 5.9l-3.63 5.73V30.1l3.63-5.54V5.9z"
      fill="#35518e"
    />
    <path
      d="M57.03 18.95V3.8l-2.28.06L53.4 5.9v18.65l3.63-5.6z"
      fill="#36528f"
    />
    <path
      d="M60.48 13.78h.24V3.8h-3.7v15.14l3.45-5.17z"
      fill="#38548f"
    />
    <path
      d="M60.72 3.8h3.63v10.03h-3.63z"
      fill="#395490"
    />
    <path
      d="M64.35 3.74h3.63v10.03h-3.63z"
      fill="#3b5690"
    />
    <path
      d="M68.05 3.74h3.63v10.1h-3.63z"
      fill="#3b5691"
    />
    <path
      d="M71.68 3.68h3.63v10.1h-3.63z"
      fill="#3d5790"
    />
    <path
      d="M75.278 3.692l3.63-.03.083 10.16-3.63.03z"
      fill="#3f5992"
    />
    <path
      d="M79 3.6h3.63v10.16H79z"
      fill="#405893"
    />
    <path
      d="M82.605 3.63l3.63-.027.076 10.16-3.63.027z"
      fill="#415992"
    />
    <path
      d="M86.27 3.6h3.63v10.22h-3.63z"
      fill="#425a93"
    />
    <path
      d="M89.96 3.54h3.63v10.22h-3.63z"
      fill="#425c94"
    />
    <path
      d="M93.6 3.54h3.63v10.28H93.6z"
      fill="#435d94"
    />
    <path
      d="M97.195 3.318l3.63-.036.103 10.28-3.63.036z"
      fill="#435e94"
    />
    <path
      d="M100.92 3.48h3.63v10.34h-3.63z"
      fill="#445f96"
    />
    <g fill="#455f96">
      <path d="M104.516 3.43l3.63-.032.092 10.34-3.63.032z" />
      <path d="M108.18 3.4h3.63v10.4h-3.63z" />
    </g>
    <g fill="#476198">
      <path d="M111.87 3.35h3.63v10.4h-3.63z" />
      <path d="M115.5 3.35h3.63v10.4h-3.63z" />
    </g>
    <path
      d="M119.13 3.35h3.63V13.8h-3.63z"
      fill="#486399"
    />
    <path
      d="M122.83 3.28h3.63v10.46h-3.63z"
      fill="#496399"
    />
    <path
      d="M126.43 3.29l3.63-.028.08 10.53-3.63.028z"
      fill="#49659a"
    />
    <path
      d="M130.1 3.22h3.63v10.53h-3.63zm3.68 0h3.63v10.6h-3.63z"
      fill="#4c669b"
    />
    <path
      d="M137.42 3.15h3.63v10.6h-3.63z"
      fill="#4c679c"
    />
    <path
      d="M141.05 3.15h3.63V13.8h-3.63z"
      fill="#4f689c"
    />
    <path
      d="M144.74 3.1h3.63v10.65h-3.63z"
      fill="#4f689d"
    />
    <path
      d="M148.37 3.1H152v10.65h-3.63z"
      fill="#506a9d"
    />
    <path
      d="M151.97 3.11l3.63-.027.08 10.7-3.63.027z"
      fill="#516b9f"
    />
    <path
      d="M155.7 3.02h3.63v10.7h-3.63z"
      fill="#536b9f"
    />
    <path
      d="M159.33 3.02h3.63V13.8h-3.63z"
      fill="#556c9f"
    />
    <path
      d="M162.93 2.973l3.63-.03.088 10.77-3.63.03z"
      fill="#556ca0"
    />
    <path
      d="M166.65 2.96h3.63V13.8h-3.63z"
      fill="#576da0"
    />
    <path
      d="M170.3 2.9h3.63v10.83h-3.63z"
      fill="#596fa1"
    />
    <path
      d="M173.92 2.9h3.63v10.9h-3.63z"
      fill="#596fa2"
    />
    <path
      d="M177.6 2.83h3.63v10.9h-3.63z"
      fill="#5a6fa0"
    />
    <path
      d="M181.24 2.83h3.63v10.9h-3.63z"
      fill="#5a71a3"
    />
    <path
      d="M184.87 2.76h3.63v10.96h-3.63z"
      fill="#5c72a2"
    />
    <g fill="#5d73a3">
      <path d="M188.57 2.76h3.63v10.96h-3.63z" />
      <path d="M192.2 2.76h3.63v11.02h-3.63z" />
    </g>
    <path
      d="M195.83 2.7h3.63v11.02h-3.63z"
      fill="#5e74a4"
    />
    <path
      d="M199.52 2.7h3.63v11.08h-3.63z"
      fill="#5f74a5"
    />
    <path
      d="M203.15 2.63h3.63V13.7h-3.63z"
      fill="#6176a6"
    />
    <path
      d="M206.8 2.63h3.63v11.14h-3.63z"
      fill="#6277a7"
    />
    <path
      d="M210.48 2.57h3.63V13.7h-3.63z"
      fill="#6279a7"
    />
    <path
      d="M214.1 2.57h3.63v11.2h-3.63z"
      fill="#6379a8"
    />
    <path
      d="M217.74 2.5h3.63v11.2h-3.63z"
      fill="#647aa8"
    />
    <path
      d="M221.44 2.5h3.63v11.2h-3.63z"
      fill="#657ba9"
    />
    <path
      d="M225.07 2.5h3.63v11.26h-3.63z"
      fill="#657bab"
    />
    <path
      d="M228.7 2.44h3.63V13.7h-3.63z"
      fill="#677daa"
    />
    <path
      d="M232.4 2.44h3.63v11.33h-3.63z"
      fill="#667dab"
    />
    <path
      d="M236.02 2.37h3.63V13.7h-3.63z"
      fill="#697eab"
    />
    <path
      d="M239.66 2.37h3.63v11.4h-3.63z"
      fill="#697fab"
    />
    <path
      d="M243.35 2.3h3.63v11.4h-3.63z"
      fill="#6c80ab"
    />
    <path
      d="M246.98 2.3h3.63v11.45h-3.63z"
      fill="#6b80ac"
    />
    <path
      d="M250.6 2.24h3.63V13.7h-3.63z"
      fill="#6c81ad"
    />
    <path
      d="M254.3 2.24h3.63V13.7h-3.63z"
      fill="#6c80ac"
    />
    <path
      d="M257.94 2.24h3.63v11.5h-3.63z"
      fill="#6d81ad"
    />
    <path
      d="M261.57 2.18h3.63v11.5h-3.63z"
      fill="#6f83ae"
    />
    <path
      d="M260.83 2.18h4.43v11.57h-4.43z"
      fill="#7184ae"
    />
    <path
      d="M260.83 2.12h3.63V13.7h-3.63z"
      fill="#7185af"
    />
    <path
      d="M264.52 2.1h3.63v11.63h-3.63z"
      fill="#7285af"
    />
    <path
      d="M268.15 2.05h3.63v11.63h-3.63z"
      fill="#7386b1"
    />
    <path
      d="M271.8 2.05h3.63v11.7h-3.63z"
      fill="#7387b0"
    />
    <path
      d="M275.48 2h3.63v11.7h-3.63z"
      fill="#7588b2"
    />
    <path
      d="M279.1 1.98h3.63v11.7h-3.63z"
      fill="#7689b2"
    />
    <path
      d="M282.74 1.98h3.63v11.76h-3.63z"
      fill="#788ab2"
    />
    <path
      d="M286.44 1.92h3.63v11.76h-3.63z"
      fill="#788ab4"
    />
    <path
      d="M290.07 1.92h3.63v11.82h-3.63z"
      fill="#7b8db4"
    />
    <path
      d="M293.7 1.85h3.63v11.82h-3.63z"
      fill="#7a8cb4"
    />
    <path
      d="M297.4 1.85h3.63v11.88h-3.63z"
      fill="#7b8bb4"
    />
    <path
      d="M301.02 1.8h3.63v11.88h-3.63z"
      fill="#7c8eb6"
    />
    <path
      d="M305.33 13.67l3.02-5.36V1.8h-3.7l.01 11.88h.67z"
      fill="#7d8eb5"
    />
    <path
      d="M311.98 1.72l-3.63.07V8.3l3.63-6.6z"
      fill="#7d8fb6"
    />
    <g class="Ad">
      <path
        class="Bj"
        d="M31.34 90.3l8.8-8.5a32.83 32.83 0 0 1 7-5.48 9.18 9.18 0 0 1 6-.74c2.15.5 4.68 2.15 7.5 5.1 1.9 2 3 3.7 3.08 5s-.5 3.2-2 5.36c2.53-1.54 4.62-2.1 6.4-1.73S71.84 91 74 93.24l3 3.13a17.83 17.83 0 0 1 4.19 5.85 5.9 5.9 0 0 1-.31 4.68c-.74 1.54-2.9 4-6.46 7.45l-10.2 9.85zm14.52-2.72l7.33 7.57a11.43 11.43 0 0 1 .86-.86c.86-.8 1.17-1.54 1-2.22s-1.23-2-3.2-4a9.07 9.07 0 0 0-2.46-2 1.9 1.9 0 0 0-1.54-.06 7.25 7.25 0 0 0-1.99 1.57zm12.44 12.86l9.24 9.56c1.17-1.23 1.78-2.15 1.78-2.83s-.68-1.72-2-3.08l-3.08-3.2c-1.42-1.47-2.4-2.2-3-2.2s-1.65.53-2.94 1.76z"
      />
      <path
        class="Bi"
        d="M64.22 125.25L30.47 90.3l9.3-8.93a32.77 32.77 0 0 1 7.08-5.54 9.2 9.2 0 0 1 6.46-.74c2.28.5 4.87 2.2 7.82 5.3 2 2.1 3.08 3.87 3.27 5.4a7.21 7.21 0 0 1-.92 3.88 8.05 8.05 0 0 1 4.92-.74c1.9.37 3.94 1.78 6.22 4.06l3.08 3.14a19 19 0 0 1 4.31 6.09 6.35 6.35 0 0 1-.37 5.17c-.8 1.6-2.95 4.06-6.58 7.57zm-32-34.9l32 33.16L74 114.1c3.5-3.4 5.6-5.85 6.34-7.26a5.24 5.24 0 0 0 .31-4.19 16.33 16.33 0 0 0-4-5.66l-3.08-3.14c-2-2.1-3.94-3.38-5.54-3.7s-3.63.25-6 1.66l-.78-.82c1.35-2 2-3.75 1.84-5s-1.1-2.85-2.9-4.7c-2.77-2.83-5.2-4.5-7.2-4.92a7.93 7.93 0 0 0-5.61.68 32.81 32.81 0 0 0-6.83 5.36zm35.32 20.54l-10.16-10.52.5-.43c1.48-1.3 2.52-2 3.26-2h.06c.56 0 1.42.3 3.45 2.4l3.08 3.2c1.48 1.54 2.15 2.64 2.15 3.5s-.6 1.9-2 3.26zm-8.38-10.4l8.3 8.6c1-1.17 1.17-1.73 1.17-1.9s-.18-.92-1.84-2.65l-3.08-3.2c-1.85-1.9-2.47-2-2.6-2h0c-.13-.1-.68.04-1.97 1.15zm-6-4.5L45 87.52l.5-.43a10.45 10.45 0 0 1 2.15-1.66 2.6 2.6 0 0 1 2 .06 9.29 9.29 0 0 1 2.64 2.09c2.7 2.83 3.2 3.82 3.33 4.3.25.92-.12 1.85-1.17 2.83-.18.2-.5.5-.8.86zm-6.47-8.43l6.4 6.65a2.83 2.83 0 0 0 .37-.43c.5-.43 1-1.1.86-1.6-.06-.25-.5-1.1-3-3.76a8.33 8.33 0 0 0-2.22-1.84 1.21 1.21 0 0 0-1-.06 12.85 12.85 0 0 0-1.39 1.04z"
      />
      <path
        class="Bj"
        d="M103.53 68.66a99.69 99.69 0 0 1 5 8.74 11.42 11.42 0 0 1 1.11 5.72 11.11 11.11 0 0 1-2 5.73 16.4 16.4 0 0 1-5.23 4.8A17.72 17.72 0 0 1 96 96.24a10.76 10.76 0 0 1-6.1-.61 11.2 11.2 0 0 1-4.74-3.45 102.07 102.07 0 0 1-5.73-8.49l-4.34-6.9c-2.52-4.06-4.2-7-5-8.74a11.4 11.4 0 0 1-1.11-5.72 11.14 11.14 0 0 1 2-5.73 17.35 17.35 0 0 1 5.23-4.8 17.72 17.72 0 0 1 6.46-2.59 11.25 11.25 0 0 1 10.84 4q1.85 2.3 5.73 8.5zM84.8 62a16.43 16.43 0 0 0-2.52-3.38 1.49 1.49 0 0 0-1.73 0 1.69 1.69 0 0 0-.86 1.42c0 .6.62 1.9 1.9 4l11.7 18.7a25.31 25.31 0 0 0 3 4.13 1.39 1.39 0 0 0 1.79 0 1.52 1.52 0 0 0 .73-1.78 22.49 22.49 0 0 0-2.52-4.68z"
      />
      <path
        class="Bi"
        d="M93.88 97a11 11 0 0 1-4.25-.8 11.91 11.91 0 0 1-5-3.62c-1.23-1.54-3.2-4.44-5.8-8.56l-4.3-6.9a92.77 92.77 0 0 1-5.11-8.8 11.82 11.82 0 0 1 1-12.06 17.59 17.59 0 0 1 5.41-5 18.72 18.72 0 0 1 6.65-2.65 12 12 0 0 1 11.45 4.24c1.23 1.54 3.2 4.43 5.8 8.55l4.28 6.94c2.52 4.07 4.25 7 5.1 8.8a11.9 11.9 0 0 1-1 12.07 17.72 17.72 0 0 1-5.41 5 18.91 18.91 0 0 1-6.65 2.65 13.82 13.82 0 0 1-2.17.13zm-9.13-47.3a10.5 10.5 0 0 0-2 .19 17.94 17.94 0 0 0-6.22 2.46 17.12 17.12 0 0 0-5 4.68 11.45 11.45 0 0 0-2 5.42 10.79 10.79 0 0 0 1 5.42 98.72 98.72 0 0 0 5.05 8.67l4.42 6.9a95.71 95.71 0 0 0 5.67 8.43 11.07 11.07 0 0 0 4.49 3.26 10.29 10.29 0 0 0 5.79.55 17.81 17.81 0 0 0 6.21-2.47 16.74 16.74 0 0 0 5-4.68 10.72 10.72 0 0 0 2-5.41 10.87 10.87 0 0 0-1-5.42A100.46 100.46 0 0 0 103 69l-4.3-6.9a98.61 98.61 0 0 0-5.66-8.43 11 11 0 0 0-4.5-3.26 10.29 10.29 0 0 0-3.78-.71zm12.38 38.1h0a2 2 0 0 1-1.23-.49c-.37-.3-1.1-1.1-3.08-4.3l-11.7-18.7c-1.8-2.9-2-3.8-2-4.37A2.42 2.42 0 0 1 80.19 58a2.05 2.05 0 0 1 2.47.06 16.22 16.22 0 0 1 2.71 3.57l11.5 18.48c1.54 2.47 2.4 4 2.6 4.87a2.08 2.08 0 0 1-1 2.46 2.68 2.68 0 0 1-1.34.37zM81.43 59a1 1 0 0 0-.56.18 1 1 0 0 0-.55.86c0 .2.12.93 1.78 3.63l11.7 18.66a23.3 23.3 0 0 0 2.83 4 .69.69 0 0 0 .43.19h0a1 1 0 0 0 .62-.25c.5-.3.6-.62.5-1a22.91 22.91 0 0 0-2.46-4.49L84.2 62.27a14.85 14.85 0 0 0-2.41-3.2.51.51 0 0 0-.36-.07z"
      />
      <path
        class="Bj"
        d="M142.1 26.05l13.07 45.48-10.34 3L136 43.78l4.7 31.88-7.27 2.16L120.45 49 129 79l-10.34 3-13.06-45.47 15.26-4.38 9.2 20.37-3.4-22z"
      />
      <path
        class="Bi"
        d="M118.24 82.8L104.8 36.1l16.43-4.68.24.5c1.24 2.58 2.65 5.72 4.2 9.3l3.08 6.8L126 30l16.55-4.75L156 72l-11.6 3.3L138 53l3.4 23.2-8.3 2.4-9.6-21.35 6.34 22.27zM106.4 37l12.7 44.3 9.17-2.65-8.45-29.46 1.17-.43 12.75 28.3 6.25-1.8-4.66-31.4 1.23-.24 8.7 30.1 9.17-2.65-12.7-44.3-14.28 4.07 3.34 21.48-1.17.37-5-11.08-3.95-8.8z"
      />
      <path
        class="Bj"
        d="M160 23.4l12.26-.4a31.75 31.75 0 0 1 8.8.61 8.53 8.53 0 0 1 4.94 3.47c1.3 1.78 2 4.74 2.16 8.8.12 2.77-.25 4.68-1.1 5.85s-2.52 2-5 2.7c2.9.55 4.86 1.53 5.9 3s1.66 3.76 1.78 6.83l.2 4.37a16.94 16.94 0 0 1-.86 7.14 5.88 5.88 0 0 1-3.38 3.27c-1.6.6-4.86 1-9.8 1.17l-14.22.5zm12.62 7.68L173 41.6a9.77 9.77 0 0 1 1.23-.06c1.17-.06 1.9-.37 2.2-1s.43-2.34.3-5.1a9.6 9.6 0 0 0-.49-3.07 2.37 2.37 0 0 0-1.11-1.11 6.61 6.61 0 0 0-2.52-.18zm.63 17.85l.43 13.3c1.73-.12 2.77-.43 3.2-.92s.62-1.73.56-3.64l-.13-4.43c-.06-2-.3-3.26-.74-3.7s-1.57-.62-3.3-.62z"
      />
      <path
        class="Bi"
        d="M161.08 71.4l-1.74-48.57 12.86-.43a32.47 32.47 0 0 1 9 .61 9.21 9.21 0 0 1 5.29 3.75c1.36 1.9 2.1 4.92 2.28 9.17.13 3-.3 5-1.22 6.22a7.68 7.68 0 0 1-3.27 2.22 8.1 8.1 0 0 1 4.19 2.7c1.17 1.54 1.8 3.94 1.9 7.14l.13 4.37c.12 3.32-.2 5.73-.92 7.4a6.44 6.44 0 0 1-3.76 3.63c-1.66.68-4.92 1-10 1.24zm-.4-47.4l1.62 46 13.6-.5c4.87-.18 8.07-.55 9.54-1.17a5.27 5.27 0 0 0 3-3 17.32 17.32 0 0 0 .8-6.89l-.2-4.37c-.13-2.95-.68-5.1-1.67-6.46s-2.83-2.22-5.54-2.77l-.06-1.23c2.4-.62 3.94-1.48 4.68-2.47s1-2.83 1-5.4q-.18-5.9-2-8.5a8 8 0 0 0-4.62-3.26 33.8 33.8 0 0 0-8.62-.55zm12.45 38.9l-.5-14.6h.68c2 0 3.2.24 3.75.8.37.37.87 1.17.93 4.12l.12 4.43c.07 2.16-.12 3.45-.73 4.07s-1.73 1-3.63 1.17zm.8-13.3l.43 11.94c1.54-.18 2-.5 2.16-.68s.5-.8.42-3.2l-.12-4.43c-.12-2.64-.5-3.14-.56-3.26a4.83 4.83 0 0 0-2.33-.36zm-1.55-7.32l-.4-11.8h.6a13.12 13.12 0 0 1 2.71.18 2.56 2.56 0 0 1 1.48 1.42 9.46 9.46 0 0 1 .55 3.32c.13 3.88-.12 4.93-.36 5.42a2.9 2.9 0 0 1-2.77 1.29c-.25 0-.62.06-1.17.06zm.92-10.6l.3 9.23h.56c.6 0 1.47-.12 1.66-.6.12-.25.37-1.17.24-4.8a7.09 7.09 0 0 0-.43-2.84 1.07 1.07 0 0 0-.74-.73c-.12-.18-.55-.24-1.6-.24z"
      />
      <path
        class="Bj"
        d="M204.76 23.56l20.3 3.2-1.47 9.36-8.12-1.3-1.42 8.93 7.58 1.22-1.42 8.87-7.57-1.23-1.6 10.28 8.92 1.4-1.47 9.36-21.1-3.32 7.36-46.78z"
      />
      <path
        class="Bi"
        d="M219 74.4l-22.34-3.5 7.6-48 21.48 3.38-1.65 10.57-8.1-1.3-1.23 7.7 7.57 1.23-1.6 10.1-7.57-1.17-1.35 9 8.92 1.4zm-20.87-4.6L218 72.92l1.3-8.12-8.93-1.42 1.84-11.5 7.6 1.13 1.2-7.6-7.57-1.17 1.6-10.16 8.12 1.3 1.3-8.12-19-3z"
      />
      <path
        class="Bj"
        d="M240.9 30.44l8.18 2.95a69 69 0 0 1 10.84 4.67 8.15 8.15 0 0 1 3.57 4.94c.62 2.15.2 5.17-1.16 8.92-1.23 3.45-2.53 5.6-3.82 6.53s-3.26 1-5.84.3c2.1 1.4 3.32 2.7 3.8 3.94a6.92 6.92 0 0 1 .5 3.13 52.11 52.11 0 0 1-2.09 6.72l-4.24 11.75-10.78-3.87 5.35-14.77c.86-2.4 1.23-3.94 1-4.62s-1-1.36-2.64-1.9L236.3 79.2 224.73 75zm8.87 11.8l-3.63 9.9a4.81 4.81 0 0 0 2.89.43c.68-.18 1.35-1.23 2-3.2l.92-2.46c.5-1.42.62-2.4.25-3.08a4.89 4.89 0 0 0-2.43-1.6z"
      />
      <path
        class="Bi"
        d="M251 85.1l-12-4.3 5.6-15.4c1.1-3.08 1.1-4 1.05-4.25s-.3-.68-1.66-1.23L236.67 80l-12.74-4.67 16.6-45.68 8.8 3.2c5.54 2 9.17 3.56 11 4.73a8.89 8.89 0 0 1 3.82 5.29c.6 2.34.25 5.36-1.23 9.3-1.3 3.63-2.64 5.85-4.06 6.83a5.64 5.64 0 0 1-3.82.8 7 7 0 0 1 2 2.71 7.49 7.49 0 0 1 .55 3.45 45.14 45.14 0 0 1-2.15 6.83zm-10.34-5l9.54 3.5 4.06-11.15a41.57 41.57 0 0 0 2.09-6.52 7 7 0 0 0-.49-2.9c-.37-1.1-1.6-2.33-3.5-3.63l.5-1.1c2.4.6 4.25.55 5.35-.2s2.4-2.9 3.57-6.22c1.35-3.63 1.72-6.53 1.17-8.56a7.41 7.41 0 0 0-3.27-4.55q-2.66-1.7-10.76-4.65l-7.57-2.77L225.6 74.7l10.4 3.8 7.32-20.07.6.2c1.8.68 2.78 1.4 3 2.34.13.55.13 1.66-1.1 5zm7.87-26.78h0a7.52 7.52 0 0 1-2.53-.55l-.6-.25 4.06-11.08.6.2a5 5 0 0 1 2.83 2c.43.8.37 2-.24 3.57l-.86 2.47c-.8 2.28-1.6 3.32-2.46 3.57a2 2 0 0 1-.85.04zM247 51.77a5.43 5.43 0 0 0 1.54.31h0a1 1 0 0 0 .43-.06c.12 0 .67-.3 1.6-2.83l.86-2.47c.6-1.6.43-2.27.3-2.52s-.55-.68-1.6-1.1z"
      />
      <path
        class="Bj"
        d="M291.1 85.7a93.64 93.64 0 0 1-5.66 8.38 11.35 11.35 0 0 1-10.71 4.19 17.27 17.27 0 0 1-6.65-2.59A17.05 17.05 0 0 1 263 91a11.39 11.39 0 0 1-2.16-5.73 10.66 10.66 0 0 1 1.05-5.72c.86-1.8 2.52-4.74 5.1-8.87l4.3-6.9a94 94 0 0 1 5.66-8.38 11.56 11.56 0 0 1 4.67-3.51 11.7 11.7 0 0 1 6-.68 17.27 17.27 0 0 1 6.65 2.59 17.05 17.05 0 0 1 5.11 4.67 11.38 11.38 0 0 1 1.18 11.45 100.88 100.88 0 0 1-5.11 8.87zm-2.23-19.76a14.5 14.5 0 0 0 1.91-3.75 1.41 1.41 0 0 0-.74-1.54 1.64 1.64 0 0 0-1.6-.12c-.56.24-1.48 1.4-2.77 3.45L274 82.68a19.65 19.65 0 0 0-2.4 4.5 1.42 1.42 0 0 0 .81 1.6 1.47 1.47 0 0 0 1.9-.13 23 23 0 0 0 3.08-4.31z"
      />
      <path
        class="Bi"
        d="M276.63 99c-.62 0-1.3-.06-2-.12a17.8 17.8 0 0 1-6.9-2.7 18.45 18.45 0 0 1-5.29-4.8 11.67 11.67 0 0 1-2.28-6 12.05 12.05 0 0 1 1-6.1 99.08 99.08 0 0 1 5.17-8.93l4.3-6.9c2.52-4 4.43-6.84 5.66-8.44a11.71 11.71 0 0 1 4.92-3.69 12.4 12.4 0 0 1 6.41-.74 17.66 17.66 0 0 1 6.89 2.7 18.35 18.35 0 0 1 5.3 4.8 11.85 11.85 0 0 1 2.28 6 12.16 12.16 0 0 1-1.05 6.1c-.8 1.8-2.5 4.8-5.04 8.9l-4.36 6.9c-2.58 4.12-4.43 6.83-5.66 8.43a11.65 11.65 0 0 1-4.92 3.7 12.17 12.17 0 0 1-4.43.87zm9.1-47.34a10.59 10.59 0 0 0-8.37 4.07 100.09 100.09 0 0 0-5.6 8.31l-4.3 6.9c-2.52 4.12-4.24 7.08-5.1 8.8a10.1 10.1 0 0 0-.92 5.42 10.66 10.66 0 0 0 2 5.42 17.44 17.44 0 0 0 4.93 4.49 17.2 17.2 0 0 0 6.4 2.52 11.1 11.1 0 0 0 5.75-.59 11.21 11.21 0 0 0 4.43-3.26c1.23-1.54 3.08-4.3 5.6-8.32l4.3-6.9c2.52-4.07 4.24-7 5.1-8.8a10.07 10.07 0 0 0 .92-5.41 10.62 10.62 0 0 0-2-5.42 17.31 17.31 0 0 0-4.93-4.49 16.82 16.82 0 0 0-6.4-2.52 9.47 9.47 0 0 0-1.81-.23zm-12.48 38.1h0a2.54 2.54 0 0 1-1.29-.37 1.93 1.93 0 0 1-1.05-2.27c.12-.5.5-1.48 2.52-4.68l11.7-18.72c1.78-2.9 2.58-3.5 3-3.7a2.38 2.38 0 0 1 2.22.18 2 2 0 0 1 1 2.21 14.48 14.48 0 0 1-2 4L277.85 84.9a24.61 24.61 0 0 1-3.2 4.43 2.69 2.69 0 0 1-1.41.43zM289.1 61a1.21 1.21 0 0 0-.44.12c-.12.06-.8.5-2.46 3.2L274.53 83a20 20 0 0 0-2.34 4.31c-.06.3-.06.62.5 1a1.32 1.32 0 0 0 .62.19h0a.73.73 0 0 0 .55-.25 21.58 21.58 0 0 0 3-4.18l11.5-18.48a12.22 12.22 0 0 0 1.8-3.59c.06-.24.06-.6-.5-.92a1.81 1.81 0 0 0-.55-.08z"
      />
      <path
        class="Bj"
        d="M328.1 100.26l-8.38-7.8 2.4-2.6a6.06 6.06 0 0 0 1.78-2.58 1.66 1.66 0 0 0-.61-1.48 1.9 1.9 0 0 0-1.85-.49 5.74 5.74 0 0 0-2.28 1.6 8.52 8.52 0 0 0-2 3c-.25.86-.06 2.34.55 4.5 1.8 6.1 2.47 10.4 2.1 12.93s-2.15 5.4-5.3 8.8a18.57 18.57 0 0 1-6 4.68 9.42 9.42 0 0 1-6.09-.18 18.31 18.31 0 0 1-6.9-4.18 17.87 17.87 0 0 1-4.86-7.14 9.32 9.32 0 0 1-.13-6.59A25.84 25.84 0 0 1 295.4 96l2.1-2.28 8.38 7.8-3.94 4.2a7.19 7.19 0 0 0-2 2.83 1.8 1.8 0 0 0 .74 1.73 2 2 0 0 0 2 .55 5.34 5.34 0 0 0 2.4-1.66c1.9-2 2.9-3.64 2.9-4.8a38.12 38.12 0 0 0-1.3-7.07 57.52 57.52 0 0 1-1.41-7.39 10 10 0 0 1 .79-4.43 16.11 16.11 0 0 1 3.51-5.17c2.45-2.68 4.6-4.3 6.45-4.9a9.11 9.11 0 0 1 6 .18 17.93 17.93 0 0 1 6.4 4.06 19.16 19.16 0 0 1 4.93 6.71 8.55 8.55 0 0 1 .62 5.91c-.55 1.66-2.1 3.82-4.68 6.6z"
      />
      <path
        class="Bi"
        d="M306.18 122a14.34 14.34 0 0 1-3.75-.61 19.47 19.47 0 0 1-7.14-4.31 18 18 0 0 1-5.05-7.38 9.5 9.5 0 0 1-.07-7 24.89 24.89 0 0 1 4.92-7l2.52-2.7 9.3 8.68-4.37 4.68c-1.53 1.66-1.78 2.28-1.84 2.52s-.12.56.55 1.17a1.26 1.26 0 0 0 1.42.37 5.12 5.12 0 0 0 2.09-1.54c2.22-2.4 2.7-3.7 2.7-4.37a39.68 39.68 0 0 0-1.24-6.89 52.18 52.18 0 0 1-1.42-7.45 11.58 11.58 0 0 1 .8-4.74 18.58 18.58 0 0 1 3.63-5.43c2.6-2.77 4.74-4.43 6.7-5a10.17 10.17 0 0 1 6.34.18 18.44 18.44 0 0 1 6.65 4.18 20.31 20.31 0 0 1 5.05 6.9 9.1 9.1 0 0 1 .62 6.34c-.56 1.78-2.16 4-4.8 6.83l-1.72 1.85-9.3-8.62 2.83-3a6.27 6.27 0 0 0 1.66-2.28c.06-.2 0-.5-.43-.92a1.19 1.19 0 0 0-1.23-.31 4.29 4.29 0 0 0-2 1.42 6.66 6.66 0 0 0-1.79 2.77c-.12.5-.18 1.66.56 4.18 1.8 6.28 2.47 10.6 2.1 13.17s-2.22 5.67-5.48 9.18a18.63 18.63 0 0 1-6.15 4.8 12.14 12.14 0 0 1-2.68.33zm-8.5-27.26L296 96.52a23.64 23.64 0 0 0-4.68 6.59 8.47 8.47 0 0 0 .13 6.16 16.64 16.64 0 0 0 4.74 6.83 17.92 17.92 0 0 0 6.65 4.06 9.07 9.07 0 0 0 5.66.18 17 17 0 0 0 5.72-4.5c3.08-3.26 4.8-6.16 5.17-8.5s-.3-6.65-2-12.62c-.67-2.28-.86-3.82-.55-4.8a7.8 7.8 0 0 1 2.09-3.33 5.56 5.56 0 0 1 2.58-1.78 2.45 2.45 0 0 1 2.4.61 2.28 2.28 0 0 1 .8 2c-.12.68-.73 1.54-2 2.9l-2 2.1 7.45 7 .86-.92c2.46-2.65 4-4.8 4.5-6.34a7.75 7.75 0 0 0-.62-5.48 19.16 19.16 0 0 0-4.74-6.46 17 17 0 0 0-6.15-3.96 8.55 8.55 0 0 0-5.54-.18c-1.72.55-3.75 2.15-6.15 4.68a16.46 16.46 0 0 0-3.38 5 8.83 8.83 0 0 0-.74 4.18 55.35 55.35 0 0 0 1.42 7.26 39.48 39.48 0 0 1 1.29 7.21c0 1.3-1 3-3.07 5.17a5.73 5.73 0 0 1-2.71 1.85 2.73 2.73 0 0 1-2.59-.68 2.62 2.62 0 0 1-.92-2.28c.06-.43.37-1.3 2.15-3.14l3.5-3.75z"
      />
      <path
        class="Bj"
        d="M153.63 351.6h-10.28v-7a14.29 14.29 0 0 0-.31-3.82 1.39 1.39 0 0 0-1.41-.74 1.49 1.49 0 0 0-1.6.93 13 13 0 0 0-.37 4v18.65a12.17 12.17 0 0 0 .37 3.82 1.71 1.71 0 0 0 3-.07 14.45 14.45 0 0 0 .37-4.24v-5.05h10.3v1.6a32.52 32.52 0 0 1-.86 8.87 8.81 8.81 0 0 1-3.81 4.55 12.87 12.87 0 0 1-7.27 2 15 15 0 0 1-7.44-1.66 7.9 7.9 0 0 1-3.88-4.62 31.52 31.52 0 0 1-.93-8.86v-11.74a43.75 43.75 0 0 1 .31-6.52 9.5 9.5 0 0 1 1.72-4.19 9.37 9.37 0 0 1 4-3.14 14.83 14.83 0 0 1 5.91-1.17 14.36 14.36 0 0 1 7.45 1.78 8.62 8.62 0 0 1 3.88 4.43 27.7 27.7 0 0 1 .92 8.31v3.88z"
      />
      <path
        class="Bi"
        d="M141.64 375.8a16.14 16.14 0 0 1-7.76-1.72 8.75 8.75 0 0 1-4.18-5 30.46 30.46 0 0 1-1-9V348.3a54.43 54.43 0 0 1 .31-6.59 9.68 9.68 0 0 1 1.84-4.49 10.58 10.58 0 0 1 4.25-3.39 16.73 16.73 0 0 1 14 .61 9.32 9.32 0 0 1 4.13 4.8 28.57 28.57 0 0 1 1 8.49v4.43h-11.55v-7.63a15.49 15.49 0 0 0-.24-3.57c-.07-.13-.2-.37-.87-.37s-.92.37-1 .5a13.49 13.49 0 0 0-.31 3.75v18.65a12 12 0 0 0 .31 3.57c.06.25.25.5.92.5a.87.87 0 0 0 .93-.5 14 14 0 0 0 .3-4v-5.66h11.5v2.22c0 4.25-.3 7.2-.92 9a9.82 9.82 0 0 1-4.06 4.93 12.29 12.29 0 0 1-7.61 2.26zm-.26-41.9a13.69 13.69 0 0 0-5.67 1.11 9.15 9.15 0 0 0-3.75 2.95 7.87 7.87 0 0 0-1.6 3.88 54 54 0 0 0-.3 6.47V360a30.37 30.37 0 0 0 .93 8.68 7.58 7.58 0 0 0 3.57 4.25 14.4 14.4 0 0 0 7.14 1.59 12.28 12.28 0 0 0 7-1.85 8.6 8.6 0 0 0 3.57-4.24 31.06 31.06 0 0 0 .85-8.68v-.93h-9v4.43a16.1 16.1 0 0 1-.37 4.43 2.35 2.35 0 0 1-4.19 0 14.15 14.15 0 0 1-.37-4.06V345a14.72 14.72 0 0 1 .36-4.19 2.41 2.41 0 0 1 4.19-.25c.18.37.37 1.23.37 4.07v6.34h9v-3.2a28.27 28.27 0 0 0-.87-8.12 8 8 0 0 0-3.63-4.13 15.64 15.64 0 0 0-7.23-1.64z"
      />
      <path
        class="Bj"
        d="M180.9 334.05v40.25h-10.28l-.01-16.93h-3l.01 16.93h-10.28l-.02-40.25 10.28-.01v14.4h3.02l-.01-14.4h10.28z"
      />
      <path
        class="Bi"
        d="M181.53 374.92H170v-16.86h-1.8v16.86h-11.5v-41.5h11.5v14.4h1.72v-14.4h11.5v41.5zm-10.28-1.3h9v-39h-9v14.4H167v-14.4h-9v39h9v-16.88h4.25z"
      />
      <path
        class="Bj"
        d="M185.03 334.04h10.28v40.2h-10.28z"
      />
      <path
        class="Bi"
        d="M195.87 374.9h-11.5v-41.48h11.5zm-10.22-1.3h9v-39h-9z"
      />
      <path
        class="Bj"
        d="M209.58 334.03l.01 32.2h6.22v8.07h-16.43l-.02-40.25 10.22-.01z"
      />
      <path
        class="Bi"
        d="M216.43 374.9H198.7v-41.5h11.5v32.2h6.15l.07 9.3zM200 373.6h15.2v-6.77H209v-32.2h-9v39z"
      />
      <path
        class="Bj"
        d="M218.32 334.03l17.1-.01v8.06l-6.83.01v7.7h6.34l.01 7.57h-6.34v8.87l7.5-.01v8.07h-17.78l-.02-40.25z"
      />
      <path
        class="Bi"
        d="M236.74 374.9h-19v-41.5H236v9.3h-6.83v6.4h6.4v8.9h-6.4v7.57h7.5v9.35zM219 373.6h16.56v-6.77H228v-10.1h6.4v-6.34H228v-8.93h6.84v-6.77H219v38.9z"
      />
    </g>
    <path
      class="Bi"
      d="M204.8 128.5s3.87-17-15-44.68l-5-8.12s2.1 27-14.45 38.1C153 125.45 132 138 118.52 156.8c-32.48 45.26 9.27 83.28 9.27 83.28s13.37 16.06 53.62 16 55.7-15.4 55.7-15.4 22.58-21.87 21.16-44.82c-1.37-21.5-13.7-37.18-15.85-50.78-2.34-14.52 3.87-28.38 3.87-28.38s-7.82 5.36-12.12 10-7.26 10.1-7.7 9.6c-.62-.74.85-11.5-1.55-18.22-6.35-17.6-15.7-25-15.7-25s-.24 12.44-.73 19.52a47.17 47.17 0 0 1-3.68 15.91z"
    />
    <path
      d="M188.17 88.57a36.65 36.65 0 0 1-16.3 30c-11.57 7.82-32.12 17.62-50.4 41.7s-12.9 56.63 11.85 78.84c16.14 14.46 31 .17 48.32-2.3a11.11 11.11 0 0 0 5.11-2.4s2-4.62-1.73-13c-3-6.65-7.64-25.8-7.34-34.16.8-21 14.45-32.57 19.3-42.85 3.56-7.63 4.9-19.2 1.83-31.45s-10.66-24.38-10.66-24.38z"
      fill="#212d54"
    />
    <g fill="#284787">
      <path
        d="M156.85 237.72a71.4 71.4 0 0 1-27.71-5.58A76.76 76.76 0 0 0 135 238c15.77 14.15 30.35.17 47.28-2.24a22.14 22.14 0 0 1 5.9.06 24 24 0 0 0 0-5.29 46.05 46.05 0 0 1-3.69 1.66 71.25 71.25 0 0 1-27.64 5.53zm29.48-135.36a69.93 69.93 0 0 1 10.1 5.66l1.3.86a119.24 119.24 0 0 0-8.93-19.45 39.44 39.44 0 0 1-2.46 12.93z"
      />
      <path
        d="M186.33 102.36l-.37 1a70.08 70.08 0 0 1 9.85 5.54l2.4 1.72-.55-1.66a13.76 13.76 0 0 0-1.29-.86 66.58 66.58 0 0 0-10.04-5.74zm-29.5 134.32a69.69 69.69 0 0 1-29.3-6.39l1.6 1.85a70.33 70.33 0 0 0 27.71 5.58 69.49 69.49 0 0 0 27.57-5.61l3.7-1.66a7 7 0 0 0-.12-1.11l-3.94 1.85a69.45 69.45 0 0 1-27.21 5.49z"
      />
    </g>
    <path
      d="M186 103.34l-.37 1a64.4 64.4 0 0 1 9.67 5.47l3.5 2.52-.5-1.66-2.4-1.72a71.88 71.88 0 0 0-9.91-5.61zM156.84 235.7a69 69 0 0 1-30.84-7.25l1.54 1.9a70.28 70.28 0 0 0 56.51.9c1.35-.55 2.64-1.17 3.94-1.85l-.2-1.1-4.18 2a69.31 69.31 0 0 1-26.78 5.4z"
      fill="#284888"
    />
    <path
      d="M185.6 104.33a5.82 5.82 0 0 1-.43.92 69.09 69.09 0 0 1 9.55 5.35l4.55 3.32-.43-1.66-3.5-2.52a78.15 78.15 0 0 0-9.73-5.41zm-28.76 130.32a67.53 67.53 0 0 1-32.32-8.17l1.48 1.9a69 69 0 0 0 57.62 1.82l4.18-2-.18-1c-1.42.74-2.9 1.4-4.43 2a66.31 66.31 0 0 1-26.35 5.45z"
      fill="#284889"
    />
    <path
      d="M123.1 224.5l1.4 2a67.84 67.84 0 0 0 58.73 2.8l4.43-2a5.71 5.71 0 0 0-.25-1.05 67 67 0 0 1-64.32-1.69zm62.06-119.25c-.12.3-.3.62-.43.92a66.85 66.85 0 0 1 14.9 9.41l-.37-1.6v-.06l-4.55-3.32a72.77 72.77 0 0 0-9.55-5.35z"
      fill="#294a8a"
    />
    <path
      d="M184.24 107.16a64.6 64.6 0 0 1 15.7 10.15l-.3-1.66a65.17 65.17 0 0 0-14.9-9.41 6.29 6.29 0 0 0-.49.92zM121.8 222.48l1.3 2a66.91 66.91 0 0 0 64.26 1.69c-.06-.37-.18-.68-.25-1a65.82 65.82 0 0 1-65.31-2.67z"
      fill="#284a8b"
    />
    <path
      d="M120.64 220.44c.37.68.8 1.36 1.24 2a65.69 65.69 0 0 0 65.24 2.67c-.12-.3-.18-.67-.3-1a64.59 64.59 0 0 1-66.18-3.67zm63.1-112.36a65.8 65.8 0 0 1 16.5 10.92 16.13 16.13 0 0 0-.31-1.66 66.43 66.43 0 0 0-15.7-10.15 6.85 6.85 0 0 0-.49.89z"
      fill="#284a8c"
    />
    <path
      d="M183.2 108.94a61.94 61.94 0 0 1 17.24 11.63 15.8 15.8 0 0 0-.24-1.66A63.71 63.71 0 0 0 183.7 108a3.19 3.19 0 0 1-.5.94zm-63.73 109.4l1.17 2.1a64.59 64.59 0 0 0 66.18 3.67c-.13-.3-.2-.68-.3-1a63.68 63.68 0 0 1-67-4.77z"
      fill="#284c8d"
    />
    <path
      d="M118.43 216.26l1 2.1a63.68 63.68 0 0 0 67 4.77c-.13-.3-.25-.67-.37-1a62.62 62.62 0 0 1-67.71-5.88zm64.2-106.4a64.72 64.72 0 0 1 18 12.3l-.2-1.6a64.88 64.88 0 0 0-17.24-11.63z"
      fill="#284c8e"
    />
    <path
      d="M117.44 214.17l1 2.1a62.62 62.62 0 0 0 67.71 5.88l-.37-1a61.68 61.68 0 0 1-68.33-7zM182 110.73a61.42 61.42 0 0 1 18.22 12.61l.43.43-.12-1.6a61.27 61.27 0 0 0-18-12.3 3.45 3.45 0 0 1-.53.86z"
      fill="#294c8f"
    />
    <path
      d="M116.58 212l.86 2.16a61.58 61.58 0 0 0 68.27 7l-.2-.5a4.37 4.37 0 0 1-.18-.49 60.5 60.5 0 0 1-68.76-8.18zM182 110.73l-.62.86A60.51 60.51 0 0 1 199.51 124l1.3 1.35-.07-1.6a2.49 2.49 0 0 0-.43-.43A62.47 62.47 0 0 0 182 110.73z"
      fill="#284d90"
    />
    <path
      d="M115.78 209.86l.8 2.15a60.39 60.39 0 0 0 68.69 8.16l-.36-1a59.38 59.38 0 0 1-69.13-9.33zm65.7-98.26a7.42 7.42 0 0 1-.67.86 59 59 0 0 1 18 12.37l2 2.15v-1.54l-1.3-1.35a60.42 60.42 0 0 0-18.03-12.49z"
      fill="#294e91"
    />
    <path
      d="M180.8 112.45l-.68.87A59.07 59.07 0 0 1 198 125.56c1 .92 1.84 2 2.77 2.95V127l-2-2.15a59 59 0 0 0-17.97-12.4zm-65.27 95.7a2.49 2.49 0 0 0-.43-.43l.68 2.15a59.38 59.38 0 0 0 69.13 9.33l-.37-1a58.33 58.33 0 0 1-69-10.06z"
      fill="#294e92"
    />
    <path
      d="M116.27 207.4l-1.73-1.85.62 2.16a3.48 3.48 0 0 0 .43.43 58.42 58.42 0 0 0 69.07 10.06l-.37-1a57.5 57.5 0 0 1-68-9.82zm63.85-94.08a7.53 7.53 0 0 0-.68.86 57.55 57.55 0 0 1 17.92 12.12c1.23 1.17 2.34 2.46 3.45 3.75l.06-1.54-2.77-2.95a59 59 0 0 0-17.98-12.24z"
      fill="#294f92"
    />
    <path
      d="M179.38 114.12c-.25.24-.5.55-.74.8a55.84 55.84 0 0 1 17.92 12 57.36 57.36 0 0 1 4.06 4.56c.07-.5.06-1 .13-1.54l-3.45-3.76a58 58 0 0 0-17.92-12.06zM117 206.66c-1.05-1-2-2.16-3-3.26l.5 2.15 1.73 1.85a57.41 57.41 0 0 0 68 9.82 5.38 5.38 0 0 1-.31-1 56.34 56.34 0 0 1-66.91-9.56z"
      fill="#295094"
    />
    <path
      d="M178.64 114.92a10.05 10.05 0 0 1-.8.8 55.94 55.94 0 0 1 18 12 65.49 65.49 0 0 1 4.66 5.28 12.14 12.14 0 0 0 .12-1.47l-4.06-4.56a57.16 57.16 0 0 0-17.92-12.05zm-60.9 91a51.69 51.69 0 0 1-4.18-4.68l.43 2.16 3 3.26a56.09 56.09 0 0 0 39.83 16.48 56.82 56.82 0 0 0 27.08-6.91c-.12-.3-.2-.68-.3-1a55.34 55.34 0 0 1-65.87-9.26z"
      fill="#285094"
    />
    <path
      d="M177.9 115.78l-.8.8a54.35 54.35 0 0 1 18 11.93 49 49 0 0 1 5.18 6l.18-1.47a55.78 55.78 0 0 0-4.68-5.3 54 54 0 0 0-17.88-11.96zm-59.42 89.4a54.93 54.93 0 0 1-5.23-6.09l.3 2.15a51.69 51.69 0 0 0 4.18 4.68 55.25 55.25 0 0 0 65.81 9.26c-.12-.3-.2-.67-.3-1a54 54 0 0 1-64.76-9z"
      fill="#285095"
    />
    <path
      d="M119.22 204.44A55.37 55.37 0 0 1 113 197l.25 2.15a54.93 54.93 0 0 0 5.23 6.09 54.14 54.14 0 0 0 64.76 9c-.12-.3-.18-.68-.3-1a53.2 53.2 0 0 1-63.71-8.71zM177 116.52a9 9 0 0 0-.86.8 52.92 52.92 0 0 1 18.16 11.87 53.57 53.57 0 0 1 5.73 6.77l.25-1.48a60.94 60.94 0 0 0-5.18-6 56.19 56.19 0 0 0-18.1-11.96z"
      fill="#295196"
    />
    <path
      d="M176.18 117.32l-.92.74a52.17 52.17 0 0 1 18.35 11.87 48.25 48.25 0 0 1 6.15 7.44A9.93 9.93 0 0 0 200 136a53.57 53.57 0 0 0-5.73-6.77 52.11 52.11 0 0 0-18.09-11.91zm-63.36 77.52L113 197a52.42 52.42 0 0 0 6.22 7.44 53.29 53.29 0 0 0 63.78 8.71c-.12-.3-.18-.67-.3-1a52.25 52.25 0 0 1-69.87-17.27z"
      fill="#2b5298"
    />
    <path
      d="M175.26 118.12l-.92.74a51.41 51.41 0 0 1 18.59 11.87 49.68 49.68 0 0 1 6.59 8.12 11.26 11.26 0 0 0 .31-1.41 55 55 0 0 0-6.16-7.45 51.59 51.59 0 0 0-18.41-11.87zm-62.5 74.63l.07 2.1a52.25 52.25 0 0 0 69.87 17.27c-.13-.37-.2-.68-.3-1.05a51.18 51.18 0 0 1-69.63-18.31z"
      fill="#2b5197"
    />
    <path
      d="M112.75 190.66v2.1a51.18 51.18 0 0 0 69.63 18.31c-.06-.37-.2-.68-.25-1.05a50.17 50.17 0 0 1-69.38-19.35zm61.6-71.8l-1.05.74a49.79 49.79 0 0 1 18.84 11.87 47.41 47.41 0 0 1 7 8.74l.37-1.36a52.36 52.36 0 0 0-6.59-8.12 50.67 50.67 0 0 0-18.57-11.87z"
      fill="#295299"
    />
    <path
      d="M112.87 188.56l-.12 2.1a50.15 50.15 0 0 0 69.38 19.42 8 8 0 0 1-.25-1.05 49.11 49.11 0 0 1-69-20.47zm60.43-68.96l-.68.5a2.33 2.33 0 0 1-.43.25 49.3 49.3 0 0 1 19.21 11.87 51 51 0 0 1 7.33 9.29l.37-1.3a50.07 50.07 0 0 0-25.8-20.61z"
      fill="#2a549a"
    />
    <g fill="#2a549c">
      <path
        d="M113.06 186.53l-.2 2A49 49 0 0 0 181.82 209c-.06-.37-.18-.68-.24-1.05a48 48 0 0 1-68.52-21.45zm59.18-66.2l-1.1.74A48 48 0 0 1 190.71 133a47.14 47.14 0 0 1 7.58 9.9 10.84 10.84 0 0 0 .43-1.29 46.59 46.59 0 0 0-7.33-9.29 47.27 47.27 0 0 0-19.15-11.98z"
      />
      <path
        d="M113.3 184.5c-.12.68-.18 1.36-.24 2a48 48 0 0 0 68.52 21.5c-.07-.37-.2-.67-.25-1a47 47 0 0 1-68-22.44zm57.84-63.42l-1.17.73A47.05 47.05 0 0 1 197.8 144l.5-1.23a49.25 49.25 0 0 0-7.58-9.9 48.49 48.49 0 0 0-19.57-11.79z"
      />
    </g>
    <path
      d="M113.6 182.47l-.37 2a47 47 0 0 0 68 22.38c-.06-.37-.2-.74-.25-1a46 46 0 0 1-67.41-23.36zM170 121.8l-1.17.74a46.16 46.16 0 0 1 28.51 22.7l.55-1.23a47.35 47.35 0 0 0-27.89-22.2z"
      fill="#2a549d"
    />
    <path
      d="M114.53 178.47c-.37 1.3-.67 2.65-.92 4A45.89 45.89 0 0 0 181 205.83l-.5-2.15a43.36 43.36 0 0 1-23.7 7 43.82 43.82 0 0 1-42.28-32.21zm54.27-55.92l-2.46 1.54a43.86 43.86 0 0 1 29.8 23.44l1.17-2.2v-.07a46.16 46.16 0 0 0-28.51-22.7z"
      fill="#2a579f"
    />
    <path
      d="M115.15 176.56a18.87 18.87 0 0 0-.56 2 43.82 43.82 0 0 0 65.94 25.21c-.06-.37-.2-.74-.25-1.1a42.75 42.75 0 0 1-65.13-26.07zm51.2-52.46l-1.3.8a43 43 0 0 1 30.42 23.69 10.29 10.29 0 0 0 .62-1.11 43.86 43.86 0 0 0-29.74-23.38z"
      fill="#2b57a0"
    />
    <path
      d="M115.82 174.6l-.67 2a42.81 42.81 0 0 0 65.19 26c-.06-.37-.18-.74-.24-1.1a41.74 41.74 0 0 1-64.28-26.87zM165 124.9l-1.35.8a41.68 41.68 0 0 1 31.09 23.93c.25-.37.43-.74.68-1A43 43 0 0 0 165 124.89z"
      fill="#2b59a1"
    />
    <path
      d="M163.7 125.7l-1.35.86a40.72 40.72 0 0 1 31.77 24.11l.67-1a41.68 41.68 0 0 0-31.09-23.97zm-47.14 46.98l-.74 1.9a41.74 41.74 0 0 0 64.28 26.87 8.86 8.86 0 0 0-.25-1.11 40.68 40.68 0 0 1-63.29-27.67z"
      fill="#2c59a2"
    />
    <path
      d="M162.34 126.56c-.44.3-.93.55-1.42.86a39.59 39.59 0 0 1 32.45 24.3 10.36 10.36 0 0 0 .68-1.05 40.65 40.65 0 0 0-31.71-24.11zm-44.98 44.27l-.8 1.85a40.68 40.68 0 0 0 63.29 27.67l-.2-1.1a39.61 39.61 0 0 1-62.3-28.41z"
      fill="#2b5aa4"
    />
    <g fill="#2c5aa4">
      <path
        d="M118.28 168.93l-.92 1.84a39.61 39.61 0 0 0 62.3 28.41l-.18-1.1a38.61 38.61 0 0 1-61.2-29.14zm42.72-41.5l-1.47.92a38.73 38.73 0 0 1 33.24 24.43 8.88 8.88 0 0 0 .68-1.05 39.7 39.7 0 0 0-32.45-24.3z"
      />
      <path
        d="M159.5 128.34l-1.48 1a37.44 37.44 0 0 1 34 24.48c.24-.37.5-.67.73-1a38.85 38.85 0 0 0-33.25-24.48zm-40.23 38.74c-.37.6-.68 1.23-1 1.85a38.61 38.61 0 0 0 61.2 29.14l-.2-1.16a37.57 37.57 0 0 1-60-29.83z"
      />
    </g>
    <path
      d="M120.3 166.9a14.35 14.35 0 0 1 .06-1.6l-1 1.85a37.52 37.52 0 0 0 37.56 37.28 37.08 37.08 0 0 0 22.4-7.45l-.18-1.17a36.52 36.52 0 0 1-58.8-28.91zm37.7-37.57l-1.54 1h.3a36.44 36.44 0 0 1 34.48 24.54 8.98 8.98 0 0 1 .73-1A37.38 37.38 0 0 0 158 129.33z"
      fill="#2a5ca5"
    />
    <path
      d="M156.8 130.38h-.3l-1.6 1.1a18.53 18.53 0 0 1 2-.07A35.47 35.47 0 0 1 190.6 156l.74-1.05a36.61 36.61 0 0 0-34.54-24.57zm-35.44 36.52a31.06 31.06 0 0 1 .18-3.38l-1.17 1.78-.06 1.6a36.48 36.48 0 0 0 58.74 28.91l-.2-1.17a35.44 35.44 0 0 1-57.5-27.74z"
      fill="#2d5ca6"
    />
    <path
      d="M156.8 131.42a18.53 18.53 0 0 0-2 .07l-1.72 1.17a35.08 35.08 0 0 1 3.69-.19 34.38 34.38 0 0 1 33 24.61l.74-1.1a35.45 35.45 0 0 0-33.71-24.55zm-34.4 35.48a36.18 36.18 0 0 1 .36-5.23l-1.3 1.8a31.75 31.75 0 0 0-.18 3.38 35.49 35.49 0 0 0 57.56 27.74 8.54 8.54 0 0 1-.12-1.23 34.41 34.41 0 0 1-56.33-26.45z"
      fill="#2d5ca7"
    />
    <path
      d="M156.8 132.4q-1.85 0-3.7.18l-1.85 1.3a32.24 32.24 0 0 1 5.54-.5 33.37 33.37 0 0 1 32.26 24.73l.74-1.1a34.49 34.49 0 0 0-33-24.6zm-33.4 34.5a33.23 33.23 0 0 1 .74-7.08c-.25.37-.56.68-.8 1.05a7.2 7.2 0 0 1-.62.8 37.65 37.65 0 0 0-.37 5.23 34.41 34.41 0 0 0 56.34 26.51 9.55 9.55 0 0 1-.13-1.23 33.34 33.34 0 0 1-55.16-25.28z"
      fill="#2e5da7"
    />
    <g fill="#2e5ea8">
      <path
        d="M156.8 133.45a33.27 33.27 0 0 0-5.54.5l-2 1.48a33.59 33.59 0 0 1 7.57-.93 32.34 32.34 0 0 1 31.46 24.85l.8-1.17a33.55 33.55 0 0 0-32.29-24.73zm-32.36 33.45a31.63 31.63 0 0 1 1.29-9l-1.6 2a32.83 32.83 0 0 0-.74 7.08 33.33 33.33 0 0 0 55.16 25.21l-.12-1.3a32.34 32.34 0 0 1-54-23.92z"
      />
      <path
        d="M156.8 134.5a30.84 30.84 0 0 0-7.57.93l-2.23 1.72a30.49 30.49 0 0 1 9.85-1.6 31.29 31.29 0 0 1 30.66 25c.25-.44.56-.8.8-1.24a32.4 32.4 0 0 0-31.51-24.81zm-31.32 32.4a31.49 31.49 0 0 1 2.09-11.33l-1.84 2.28a33.14 33.14 0 0 0-1.29 9 32.34 32.34 0 0 0 54 24 10.63 10.63 0 0 1-.06-1.35 31.26 31.26 0 0 1-52.89-22.63z"
      />
    </g>
    <g fill="#2f5fa9">
      <path
        d="M156.8 135.55a30.49 30.49 0 0 0-9.85 1.6l-2.83 2.22a30.28 30.28 0 0 1 42.54 22.51l.8-1.3a31.34 31.34 0 0 0-30.66-25.04zm.03 61.55A30.23 30.23 0 0 1 130 152.86l-2.4 2.7a31.34 31.34 0 0 0 29.2 42.59 31.09 31.09 0 0 0 21.6-8.69l-.06-1.42a30 30 0 0 1-21.51 9.06z"
      />
      <path
        d="M156.83 196.05a29.19 29.19 0 0 1-22.68-47.57l-4.12 4.3A30.22 30.22 0 0 0 178.37 188v-.8a3.6 3.6 0 0 1 .06-.8 28.89 28.89 0 0 1-21.6 9.65zm-.03-59.45a30.19 30.19 0 0 0-12.68 2.78l-4.5 3.88a29.18 29.18 0 0 1 46.17 20l.86-1.4a30.3 30.3 0 0 0-29.86-25.25z"
      />
    </g>
    <path
      d="M156.8 137.64a29.08 29.08 0 0 0-17.17 5.61l-5.48 5.23a29.19 29.19 0 0 0 44.28 38l.12-1.72a28.12 28.12 0 1 1 6.33-19.76l.92-1.6a29.26 29.26 0 0 0-29-25.76z"
      fill="#2e60aa"
    />
    <g fill="#2e62aa">
      <path
        d="M156.8 138.7a28.13 28.13 0 1 0 21.75 46 19.74 19.74 0 0 1 .25-2 27.13 27.13 0 1 1 5.1-15.95l1-1.85a28.12 28.12 0 0 0-28.1-26.2z"
      />
      <path
        d="M156.8 139.73a27.09 27.09 0 1 0 22 43 51.12 51.12 0 0 1 5.1-16 27.11 27.11 0 0 0-27.1-27zm0 48a20.87 20.87 0 1 1 20.86-20.87 20.87 20.87 0 0 1-20.84 20.82z"
      />
    </g>
    <g fill="#3065ad">
      <path
        d="M156.8 146a20.87 20.87 0 1 0 20.88 20.86A20.88 20.88 0 0 0 156.8 146zm0 40.63a19.82 19.82 0 1 1 19.81-19.83 19.82 19.82 0 0 1-19.79 19.84z"
      />
      <path
        d="M156.8 147.06a19.82 19.82 0 1 0 19.82 19.81 19.81 19.81 0 0 0-19.82-19.81zm0 38.53a18.78 18.78 0 1 1 18.77-18.78 18.81 18.81 0 0 1-18.76 18.78z"
      />
      <path
        d="M156.8 148.1a18.78 18.78 0 1 0 18.78 18.77 18.78 18.78 0 0 0-18.78-18.77zm0 36.44a17.73 17.73 0 1 1 17.72-17.73 17.72 17.72 0 0 1-17.71 17.73z"
      />
    </g>
    <path
      d="M156.8 149.1a17.73 17.73 0 1 0 17.73 17.72 17.72 17.72 0 0 0-17.73-17.72zm0 33.42a15.64 15.64 0 1 1 15.63-15.64 15.65 15.65 0 0 1-15.62 15.64z"
      fill="#3066ae"
    />
    <path
      d="M156.8 151.18a15.64 15.64 0 1 0 15.64 15.63 15.67 15.67 0 0 0-15.64-15.63zm0 29.24a13.54 13.54 0 1 1 13.54-13.55 13.55 13.55 0 0 1-13.53 13.55z"
      fill="#3368af"
    />
    <path
      d="M156.8 153.27a13.55 13.55 0 1 0 13.55 13.54 13.55 13.55 0 0 0-13.55-13.54zm0 26.1a12.5 12.5 0 1 1 12.49-12.5 12.5 12.5 0 0 1-12.48 12.5z"
      fill="#3567af"
    />
    <path
      d="M156.8 154.32a12.5 12.5 0 1 0 12.5 12.49 12.5 12.5 0 0 0-12.5-12.49zm0 24a11.45 11.45 0 1 1 11.44-11.46 11.44 11.44 0 0 1-11.43 11.47z"
      fill="#3369b0"
    />
    <g fill="#3569b0">
      <path
        d="M156.8 155.37a11.45 11.45 0 1 0 11.45 11.44 11.43 11.43 0 0 0-11.45-11.44zm0 21.9a10.4 10.4 0 1 1 10.4-10.41 10.43 10.43 0 0 1-10.39 10.41z"
      />
      <path
        d="M156.8 156.4a10.41 10.41 0 1 0 10.41 10.4 10.44 10.44 0 0 0-10.41-10.4zm0 15.64a5.24 5.24 0 1 1 5.23-5.24 5.31 5.31 0 0 1-5.22 5.24z"
      />
    </g>
    <path
      d="M156.8 161.65a5.23 5.23 0 1 0 5.24 5.23 5.31 5.31 0 0 0-5.24-5.23zm0 9.35a4.19 4.19 0 1 1 4.18-4.19 4.23 4.23 0 0 1-4.17 4.19z"
      fill="#386bb2"
    />
    <path
      d="M156.8 162.7a4.19 4.19 0 1 0 4.19 4.19 4.23 4.23 0 0 0-4.19-4.19zm0 7.27a3.14 3.14 0 1 1 3.13-3.15 3.17 3.17 0 0 1-3.12 3.19z"
      fill="#376cb3"
    />
    <g fill="#366db3">
      <path
        d="M156.8 163.74a3.14 3.14 0 1 0 3.14 3.14 3.16 3.16 0 0 0-3.14-3.14zm0 5.17a2.1 2.1 0 1 1 2.1-2.09 2.16 2.16 0 0 1-2.1 2.09z"
      />
      <path
        d="M156.8 164.78a2.1 2.1 0 1 0 2.1 2.1 2.17 2.17 0 0 0-2.1-2.1zm0 3.08a1 1 0 1 1 1.05-1 1 1 0 0 1-1.05 1z"
      />
      <path d="M156.8 165.83a1 1 0 1 0 1.05 1 1 1 0 0 0-1.05-1z" />
    </g>
    <path
      d="M190 215.74c-5-14-6.17-26.4-3.9-37.12s19.93-31.9 25.15-45.74c3.63-9.6 4.18-22.1 4.3-26.4a6.33 6.33 0 0 0-2.16-2.22s.13 16.2-4.3 27.95c-5.23 13.85-22.9 35-25.16 45.75s-1.1 23.14 3.9 37.1c4.93 13.6 4.13 18.7 4.13 18.7a4 4 0 0 0 2.21 0c-.05-1.77-.36-7.26-4.2-18.03z"
      fill="#8e8c8e"
    />
    <path
      class="Bj"
      d="M186 178.68c-2.28 10.7-1.1 23.15 3.9 37.12 3.88 10.77 4.2 16.18 4.2 18 2.83-.55 8.25-3.27 16.2-14.3 11.38-15.82 7.67-34.6 6.44-48.63-1.36-15.63 10.38-33.73 4.4-51.83-2.3-6.9-4.26-10.58-5.67-12.55-.12 4.3-.67 16.87-4.3 26.4-5.23 13.88-22.88 35.1-25.15 45.77z"
    />
    <path
      d="M220 215.35c6.27-13.17 5.4-22 3.55-40.07-2.16-21.66 9-37.67 14.63-44.2a25.82 25.82 0 0 1 1.11-4.31s-20.68 18.72-17.77 47.47c1.8 18.1 2.66 26.95-3.55 40.07a60.65 60.65 0 0 1-15.57 20l3.33-.13A60.31 60.31 0 0 0 220 215.35z"
      fill="#6f292c"
    />
    <path
      d="M252.1 185.24c-6.72-22.22-8.75-20.86-13-35.57a41.59 41.59 0 0 1-.93-18.65c-5.66 6.52-16.85 22.53-14.63 44.2 1.8 18.1 2.66 26.9-3.55 40.07a61.55 61.55 0 0 1-14.27 18.9c2.95-.06 7.5-.06 12.5.12a40 40 0 0 1 14.83 3.69s26.64-27.65 19.06-52.76z"
      fill="#c22f21"
    />
    <path
      d="M152.5 168.8l-1.42.6-2.4 1.1-2.4 1.17-9.6 4.44-1.48.68-.74 1.4 18.65-8.68-.12-.2-.5-.55zm13.37 16.54l1.1-20.93 18.03-5.3-1.35-.55-1.54.43-2.15.68-2.16.6-2.15.62-2.16.68-4.37 1.22-2.15.68-.74.18-.06 1.42-.24 4.06-.2 4-.24 4-.2 4.07-.18 3.2.74.92zm-22.72-25.54l-1.24-1.17-1.3-1.1-1.23-1.1-1.3-1.17-1.23-1.1-1.3-1.17-1.23-1.1-.43-.43h-.12l9.36 8.37zm24-14.72l.06 3.5.06 3.14.2.06.55.2-.2-13.54-.74.6.06 2.52.01 3.5z"
      fill="#201e21"
    />
    <g class="Bi">
      <path d="M134.96 150.58l-1.9.12.86.74.68-.06.37-.8z" />
      <path d="M134.6 151.38l-.68.06.43.43.25-.5z" />
      <path d="M136.5 151.25l.37-.8-1.9.13-.37.8 1.9-.13z" />
      <path d="M134.6 151.38l-.25.5 1.23 1.1.92-1.73-1.9.13z" />
      <path d="M138.4 151.13l.37-.8-1.9.12-.37.8 1.9-.12z" />
      <path d="M136.5 151.25l-.92 1.73 1.3 1.17 1.53-3.02-1.9.12z" />
      <path d="M140.3 151l.37-.86-1.9.2-.37.8 1.9-.13z" />
      <path d="M138.4 151.13l-1.53 3.02 1.23 1.1 2.2-4.25-1.9.13zm3.82-.25l.37-.86-1.9.12-.37.86 1.9-.12z" />
      <path d="M140.3 151l-2.2 4.25 1.3 1.17 2.83-5.54-1.9.12z" />
      <path d="M144.13 150.7l.37-.8-1.9.13-.37.86 1.9-.2z" />
      <path d="M142.22 150.88l-2.83 5.54 1.23 1.1 3.5-6.84-1.9.2zm3.8-.3l.37-.8-1.9.12-.37.8 1.9-.12z" />
      <path d="M144.13 150.7l-3.5 6.84 1.3 1.1 4.12-8.07-1.9.12z" />
      <path d="M147.94 150.45l.37-.86-1.9.18-.37.8 1.9-.12zm-14.2 27.02l.55-.24 7.32-14.35-7.87 14.6z" />
      <path d="M141.9 158.64l1.24 1.17 4.8-9.36-1.9.12-4.12 8.07z" />
      <path
        d="M149.85 150.32l.37-.86-1.9.13-.37.86 1.9-.13zm-6.65 9.55l-1.6 3-7.32 14.35.92-.43 8.74-16.2-.74-.73z"
      />
      <path
        d="M149.85 150.32l-1.9.13-4.8 9.36.06.06.74.73-8.74 16.2 1.48-.68 13.16-25.8zm1.9-.18l.37-.8-1.9.12-.37.86 1.9-.18z"
      />
      <path
        d="M149.85 150.32l-13.16 25.8 2.4-1.1 12.67-24.87-1.9.18zm3.75-.32l.55-.98-.25.18-1.78.13-.37.8 1.85-.13z"
      />
      <path
        d="M151.76 150.14L139.1 175l2.4-1.1 12.1-23.9-1.85.13zm2.9-.2l1.54-1.35 1.3-2.47-3.32 2.9-.55.98 1.04-.06z"
      />
      <path
        d="M154.65 149.95l-1.04.06-12.12 23.9 2.4-1.1 12.3-24.2-1.54 1.35zm4.85-4.25l1.3-2.52-3.32 2.95-1.3 2.47 3.32-2.9z"
      />
      <path
        d="M156.2 148.6l-12.3 24.2 2.4-1.1 13.22-25.98-3.32 2.9zm6.64-5.85l1.3-2.47-3.33 2.9-1.3 2.52 3.33-2.95z"
      />
      <path d="M159.5 145.7l-13.22 25.98 2.4-1.17 14.15-27.76-3.33 2.95z" />
      <path d="M166.16 139.85l.92-1.78v-.37l-2.95 2.58-1.3 2.47 3.32-2.9z" />
      <path d="M162.84 142.75L148.7 170.5l2.4-1.1 15.07-29.55-3.32 2.9z" />
      <path
        d="M167.08 139.05v-.98l-.92 1.78.92-.8zM151.1 169.4l1.42-.6.5.55 14.14-27.77-.06-2.52-.92.8-15.07 29.55zm2.15.13h-.13l1 1.23.06-.13-.92-1.1z"
      />
      <path d="M154.17 170.63l12.98-25.55-.01-3.5L153 169.34l.12.2h.13l.92 1.1z" />
      <path d="M154.17 170.63l-.06.13 1.1 1.4.06-.12-1.1-1.42z" />
      <path d="M167.15 145.08l-12.98 25.55 1.1 1.42 11.93-23.46-.06-3.5z" />
      <path d="M155.28 172.05l-.06.12 1.1 1.42.07-.13-1.1-1.4z" />
      <path d="M167.27 151.73l-.06-3.14-11.93 23.46 1.1 1.4 11.07-21.67-.2-.06z" />
      <path d="M156.4 173.46l-.07.13 1.1 1.4.06-.12-1.1-1.42zm12.35-20.74l.25-.37-1-.37v.5l.74.25z" />
      <path d="M156.4 173.46l1.1 1.42 11.26-22.16-.74-.25v-.5l-.55-.2-11.07 21.67z" />
      <path d="M170.3 153.33l.18-.37-1.47-.6-.25.37 1.54.6zm-12.8 21.55l-.06.12 1.17 1.42v-.13l-1.1-1.4z" />
      <path d="M168.75 152.72l-11.26 22.16 1.1 1.4 11.7-22.96-1.54-.6zm3.08 1.22l.18-.37-1.54-.6-.18.37 1.54.6z" />
      <path
        d="M158.6 176.3v.13l1.1 1.35.06-.06-1.17-1.42zm11.7-22.97l-11.7 22.96 1.17 1.42 6.4-12.62.06-1.42.74-.18 4.86-9.55-1.54-.6z"
      />
      <path d="M173.37 154.56l.18-.37-1.54-.62-.18.37 1.54.62zm-13.6 23.14l-.06.06 1.1 1.42.06-.13-1.1-1.35z" />
      <path
        d="M171.83 153.94l-4.86 9.55 2.15-.68 4.25-8.25-1.54-.62zm-10.95 25.12l5.05-9.9.24-4.06-6.4 12.62 1.1 1.35z"
      />
      <path d="M160.88 179.06l-.06.13 1.1 1.4.06-.12-1.1-1.42zm14.02-23.9l.18-.43-1.54-.55-.18.37 1.54.6z" />
      <path d="M162 180.48l3.75-7.33.2-4-5.05 9.9 1.1 1.42zm11.37-25.92l-4.25 8.25 2.22-.62 3.57-7.02-1.54-.6z" />
      <path d="M176.44 155.73l.2-.37-1.54-.62-.18.43 1.53.56zM162 180.48l-.06.12 1.1 1.42.06-.13-1.1-1.4z" />
      <path d="M163.1 181.9l2.4-4.74.24-4-3.75 7.33 1.1 1.4zm11.8-26.73l-3.57 7.02 2.15-.6 2.95-5.85-1.53-.56z" />
      <path d="M177.98 156.34l.2-.37-1.54-.6-.2.37 1.54.6zM163.1 181.9l-.06.13 1.17 1.4.06-.12-1.17-1.42z" />
      <path
        d="M164.27 183.3l1.04-2.1.2-4.07-2.4 4.74 1.17 1.42zm12.17-27.57l-2.95 5.85 2.16-.68 2.33-4.56-1.54-.6z"
      />
      <path d="M164.2 183.43l.92 1.17v-.18l-.86-1.1-.06.12zm15.32-26.47l.2-.37-1.54-.62-.2.37 1.54.62z" />
      <path d="M164.27 183.3l.86 1.1.18-3.2-1.04 2.1zm13.7-26.96l-2.33 4.56 2.15-.62 1.72-3.32-1.54-.62z" />
      <path d="M181 157.57l.18-.43-1.47-.55-.2.37 1.48.6z" />
      <path d="M179.52 156.96l-1.72 3.32 2.16-.6 1.04-2.1-1.48-.6zm3.02 1.17l.18-.37-1.54-.62-.18.43 1.54.56z" />
      <path d="M181 157.57l-1.04 2.1 2.15-.68.43-.86-1.54-.56z" />
      <path d="M183.65 158.56l.6-.2-1.54-.6-.18.37 1.1.43z" />
      <path d="M182.1 159l1.54-.43-1.1-.43-.43.86z" />
    </g>
    <path
      d="M147.33 159.62l-5.78 10.65.92-.37 5.35-9.85-.5-.43zm17.1-5.5v.56l9.85 3.75.74-.25-10.6-4.06zm-.62-8.5v-.92l-8.43 7.5-15.02 1 .8.68 14.6-1 8.06-7.27z"
      fill="#8e8c8e"
    />
    <path
      class="Bj"
      d="M164.44 154.13l-.3-.12-.3-8.37-8.06 7.27-14.6 1 6.28 5.47-.12.25.5.43-5.35 9.85 10.9-4.56 8.86 10.34.8-13.67 11.26-3.57-9.85-3.75v-.56z"
    />
    <path
      class="Bi"
      d="M105.28 279.67c0-24.44 20.3-44.27 43.5-44.28h67.83c24.07 0 43.53 17.4 43.54 44.24h0c0 24.43-19.5 44.26-43.5 44.27h-67.77c-24.07 0-43.6-19.8-43.6-44.23z"
    />
    <path
      class="Bj"
      d="M256.64 278.43a9.29 9.29 0 0 0-.06-1.29l-.06-1.3a8.56 8.56 0 0 0-.13-1.23l-.12-1.23-.2-1.17-.18-1.17a8.53 8.53 0 0 0-.25-1.17c-.06-.37-.18-.74-.24-1.1s-.2-.74-.3-1.1l-.3-1.1-.37-1.05-.74-2a7.13 7.13 0 0 0-.43-1l-.43-1a7 7 0 0 0-.5-1c-.18-.3-.3-.62-.5-1a6.85 6.85 0 0 1-.49-.92l-.56-.93-1.1-1.84a4.2 4.2 0 0 0-.62-.86 9.15 9.15 0 0 0-.62-.86c-.18-.3-.43-.56-.6-.87s-.37-.43-.56-.67a.34.34 0 0 1-.12-.19c-.25-.24-.5-.55-.74-.8l-.74-.8a8.28 8.28 0 0 0-.8-.73c-.24-.25-.55-.5-.8-.74l-.8-.74c-.25-.24-.55-.5-.86-.74a9.8 9.8 0 0 0-.86-.68l-.93-.67-.92-.68a4.77 4.77 0 0 0-1-.61c-.38-.18-.67-.44-1-.62s-.68-.43-1-.62l-1-.55-1.1-.55-1.1-.56a7.75 7.75 0 0 0-1.17-.49c-.37-.18-.8-.3-1.17-.5a10 10 0 0 0-1.23-.43l-1.3-.43-1.3-.37-1.35-.37a11.57 11.57 0 0 0-1.42-.3c-.5-.13-1-.2-1.47-.3s-1.05-.2-1.54-.25l-1.6-.18a15.63 15.63 0 0 0-1.67-.12 17.64 17.64 0 0 0-1.78-.06h-64.94a14.63 14.63 0 0 0-1.72.07c-.68 0-1.36.06-2 .12l-2.22.25-2.46.43c-1 .18-1.9.43-2.83.68a33 33 0 0 0-3.45 1.11 42 42 0 0 0-5.29 2.4 40.48 40.48 0 0 0-8 5.61 37.2 37.2 0 0 0-4.06 4.18 33.77 33.77 0 0 0-2.22 2.9l-1.6 2.46-1.23 2.15-1 2a18 18 0 0 0-.8 1.9l-.67 1.8c-.24.62-.37 1.1-.56 1.72s-.3 1.1-.43 1.67l-.37 1.53-.3 1.54c-.12.54-.2 1-.25 1.48l-.18 1.42-.13 1.4c-.07.5-.06.93-.06 1.36v2.64a11.33 11.33 0 0 0 .07 1.3 7.77 7.77 0 0 0 .12 1.23l.12 1.23.2 1.17.18 1.17.25 1.17.25 1.1a6.58 6.58 0 0 0 .31 1.11c.12.37.18.74.3 1.1l.37 1c.12.26.25.67.37 1l.37 1.05a4.74 4.74 0 0 0 .44 1c.2.32.3.68.43 1a6 6 0 0 0 .49 1c.18.3.3.68.5 1a6.94 6.94 0 0 1 .5.92l.55.93.55.92a8.25 8.25 0 0 0 .62.92 3.85 3.85 0 0 0 .62.86c.18.3.43.56.6.86l.68.87.68.86.67.8 1.48 1.6a8.33 8.33 0 0 1 .74.8 9.67 9.67 0 0 0 .8.73l.8.74c.24.24.56.5.86.74a8.6 8.6 0 0 0 .87.68l.86.67.92.68.93.68c.3.25.6.43 1 .6l1 .62 1 .6 1 .56 1.1.55a9 9 0 0 0 1.11.49c.36.2.8.3 1.17.5s.8.3 1.23.5.8.3 1.23.43l1.3.43 1.35.37c.13.06.3.06.44.12l1 .18a10.89 10.89 0 0 0 1.48.25l1.54.24 1.6.2 1.72.12c.55.06 1.23.06 1.8.06H215l2-.06 2.1-.12 2.28-.3 2.58-.5 3-.74a39.44 39.44 0 0 0 3.75-1.29 42.13 42.13 0 0 0 15.45-10.84l2.52-3.08c.6-.8 1.17-1.66 1.72-2.52l1.35-2.22 1.05-2 .86-1.9.74-1.8.6-1.72.5-1.66a15.8 15.8 0 0 0 .43-1.6 12.35 12.35 0 0 0 .31-1.54l.25-1.48.18-1.42a11.18 11.18 0 0 0 .12-1.41c.07-.43.07-.92.13-1.36s.06-.92.06-1.35v-.86a2.87 2.87 0 0 1-.33-.8z"
    />
    <path
      d="M235.35 292s-.12-1.85-2.65-5.78c-2.28-3.5-4.37-4.56-4.37-4.56v-5.78h-3.64V270h2.83s.2 4.06 3.82 4.06a3.88 3.88 0 0 0 3.88-4.06c0-2.7-2-3.82-4.5-3.82h-6v-4.3c0-1.54-2.28-3.27-5.8-3.26h-5.1v-6.4l5.72-8.56h-22.2l5.1 8.43v6.52H192.2c-11.5 0-11.45 10.84-11.45 10.84H167v-10.83h-11.75v-2.46a2.92 2.92 0 0 0 1.85-2.83V250a2.66 2.66 0 0 0-2.28-2.4h-4.5a2.63 2.63 0 0 0-2.52 2.4v3a3.63 3.63 0 0 0 2.1 3.13v2.47h-1.66l-13.85 13.85s-6.22-4.86-8.37-6-1.9.73-1 1.84 8.2 7.75 8.2 7.75h-8.68v9.17h9.3v-5.05h3v-.74l4.12 3.44c.55.44-.24 1.1-.24 3.14v8.2a14.51 14.51 0 0 1-7.88-2.15c-2.34-1.35-2.52-2.6-3.2-2.6s-1.66-.3-1.17 2.77c1.17 7.33 8.5 7.76 8.5 7.76s-2.83 8.5 4.87 13.78c5.9 4.12 14.16 1.47 17.23-4.68a12.18 12.18 0 0 0-.62-11.64l17.85-10.47v9.8h19.33a16.8 16.8 0 0 0 .49 6.52c1.3 4.25 6.23 12.62 16.87 12.62 11.88 0 15.4-10.78 15.4-10.78H238V292zm-80.28-29.63h7.26v7.2h-7.27zm-18.2 12.38l11.5-11.83v13.48l-5.16 3.6zm11.34 38.83a9.67 9.67 0 1 1 9.66-9.67 9.64 9.64 0 0 1-9.66 9.65zm11.87-24.93h-4.86v-9.3h20.2zm48.12-24.83c4.43 0 8.07 2.27 8.07 5.1s-3.63 5.07-8.06 5.07-8.07-2.28-8.07-5.1 3.63-5.1 8.06-5.1zm-22.2 1.4a5.23 5.23 0 0 1 4.43-2.71v6.77h-5.73s-.33-1.48 1.3-4.06zm-6.18 9.77H193v4.25h-13.18zm32.52 37.7a13.79 13.79 0 1 1 13.78-13.79 13.77 13.77 0 0 1-13.78 13.81zm15.38-20.62a16.85 16.85 0 0 0-31.21.19h-16.8v-6h15.82s4.8-8.37 16.56-8.38c16.86 0 20.25 14.2 20.25 14.2z"
      fill="#695825"
    />
    <path
      d="M234.73 291.36s-.12-1.84-2.65-5.78c-2.27-3.5-4.37-4.55-4.37-4.55v-5.8h-3.63v-5.85h2.83s.12 4.07 3.8 4.06a3.88 3.88 0 0 0 3.88-4.06c0-2.7-2-3.82-4.5-3.8h-6v-4.3c0-1.54-2.28-3.26-5.78-3.26h-5.24v-6.4l5.72-8.56h-22.2l5.1 8.43V258h-10.27c-11.5 0-11.45 10.86-11.45 10.86h-13.72l.05-10.84h-11.8v-2.46a3 3 0 0 0 1.85-2.84v-3.32a2.67 2.67 0 0 0-2.28-2.4h-4.5a2.63 2.63 0 0 0-2.53 2.4v3a3.65 3.65 0 0 0 2.1 3.14V258h-1.67l-13.85 13.9a97.47 97.47 0 0 0-8.37-6c-2.1-1.1-1.9.74-.92 1.85s8.2 7.75 8.2 7.75h-8.68v9.17h9.3v-5.05h3v-.74l4.13 3.45c.56.45-.25 1.1-.25 3.14v8.18a14.51 14.51 0 0 1-7.88-2.15c-2.4-1.35-2.52-2.58-3.2-2.58s-1.66-.3-1.17 2.77c1.18 7.32 8.5 7.75 8.5 7.75s-2.83 8.5 4.87 13.8c5.9 4.12 14.16 1.47 17.23-4.7a12.16 12.16 0 0 0-.62-11.63l17.85-10.47v9.78h19.33a16.74 16.74 0 0 0 .5 6.53c1.3 4.25 6.22 12.6 16.87 12.6 11.88 0 15.38-10.78 15.38-10.78h9.66v-13.22zm-80.27-29.57h7.26v7.2h-7.26zm-18.28 12.38l11.5-11.82v13.48l-5.17 3.63zM147.52 313a9.67 9.67 0 1 1 9.66-9.67 9.66 9.66 0 0 1-9.66 9.67zm11.93-25h-4.86v-9.3h20.2zm48.13-24.82c4.43 0 8.06 2.27 8.06 5.1s-3.63 5.1-8.06 5.1-8.06-2.27-8.07-5.1 3.57-5.1 8.07-5.1zm-22.3 1.42a5.28 5.28 0 0 1 4.44-2.71v6.77H184a7.54 7.54 0 0 1 1.29-4.05zm-6.15 9.8h13.18v4.25h-13.17zm32.58 37.78a13.79 13.79 0 1 1 13.78-13.79 13.76 13.76 0 0 1-13.78 13.8zM227 291.5a16.85 16.85 0 0 0-31.21.2H179v-6.1h15.8s4.8-8.38 16.56-8.38c16.86 0 20.26 14.2 20.26 14.2l-4.62.06z"
      fill="#d2a828"
    />
    <path
      d="M207.22 298.7a4.8 4.8 0 1 1 4.81 4.8 4.73 4.73 0 0 1-4.81-4.8zm-62.3 4.9a3.2 3.2 0 1 1 3.21 3.2 3.14 3.14 0 0 1-3.21-3.2z"
      fill="#695825"
    />
    <path
      d="M211.65 293.53a4.8 4.8 0 1 1-4.8 4.8 4.82 4.82 0 0 1 4.8-4.8zm-67.1 9.7a3.21 3.21 0 1 1 3.21 3.2 3.18 3.18 0 0 1-3.21-3.2z"
      fill="#d2a828"
    />
    <path
      class="Bi"
      d="M308.66 8l48.53 73.72c-.55 5.54-2.76 26.47-9.82 62.85-5.34 27.58-15.66 68.27-25.13 99-16.1 52.33-38.43 89.58-54.3 111.68-22.76 31.65-53.78 49.88-85.05 50h-.12c-31.27-.1-62.3-18.3-85.1-50-15.9-22-38.25-59.32-54.4-111.64-9.5-30.65-19.85-71.4-25.22-99C11 108.28 8.74 87.36 8.2 81.82L56.66 8.05l252-.05M313 0L52.4.12 0 79.85l.2 1.72c.06.5 1.8 22 10.06 64.7 5.24 27 15.66 68.26 25.4 99.83 14.86 48 35.68 86.34 55.57 113.9 25.44 35.26 59.12 53.15 91.56 53.26h.22c32.44-.14 66.1-18.12 91.5-53.34C294.4 332.33 315.18 294 330 246c9.7-31.52 20.1-72.77 25.3-99.85 8.23-42.66 9.95-64.2 10-64.7l.18-1.72L313 0z"
    />
  </svg>
</template>

<script>
// import logoBomberos from "../../../assets/images/logo.svg";
export default {
  name: 'LogoBomberos'
}
</script>

<style lang="scss" scoped>

.Ad {
  isolation: isolate
}

.Bi {
  fill: #f3b725
}

.Bj {
  fill: #fff
}
</style>
